import { useTypedParams } from "react-router-typesafe-routes";

import { ClientEmployeeFileUploadsCard } from "@components/Cards/ClientEmployeeFileUploadsCard/ClientEmployeeFileUploadsCard";

import { Box } from "@design-system/Box/Box";

import { routes } from "@pages/routes";

export const ApplicationFileUploads = () => {
  const { clientId, applicationId } = useTypedParams(
    routes.portal.clients.client.applications.application.fileUploads,
  );

  return (
    <Box direction="column" fullStretch>
      <ClientEmployeeFileUploadsCard
        clientId={clientId}
        applicationId={applicationId}
        pageSize={30}
      />
    </Box>
  );
};
